<template lang="pug">
  b-taginput(v-model="selectedTags" 
    :data="filteredTags" 
    type="is-primary"
    group-field="label"
    group-options="options"
    ref="taginput"
    append-to-body
    @input="updateValue"
    attached autocomplete ellipsis open-on-focus :placeholder="$t(placeholder)" @typing="getFilteredTags")
    template(v-slot="props")
      span {{props.option.firstName}} {{props.option.lastName}}
    template(#selected="props")
      b-tag(
        v-for="(tag, index) in props.tags"
        :key="index"
        rounded
        type="is-primary"
        :tabstop="false"
        ellipsis
        closable
        @close="$refs.taginput.removeTag(index, $event)") {{tag.firstName}} {{tag.lastName}}
    
    
</template>
<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'StaffTagInput',
  props: {
    value: {type: Array, default: () => []},
    placeholder: {type: String, default: ''}
  },
  data() {
    return {
      filteredTags: [],
      selectedTags: []
    }
  },

  computed: {
    ...mapGetters('location', ['activeLocations']),
    ...mapGetters('staff', ['activeServiceMembersByMainLocation', 'nonActiveServiceMembers']),
    ...mapState('auth', ['user']),
    ...mapState('staff', ['staffMap']),
    activeNonEmptyLocations() {
      return this.activeLocations.filter(
        l =>
          this.activeServiceMembersByMainLocation(l._id).length &&
          (!this.$rfLocationScope() || this.user.location === l._id)
      )
    },
    staffGroups() {
      let groups = []
      this.activeNonEmptyLocations.forEach(l => {
        groups.push({
          label: l.title,
          options: this.activeServiceMembersByMainLocation(l._id)
        })
      })
      if (this.nonActiveServiceMembers.length) {
        groups.push({
          label: this.$t('staff.archived_staff_label'),
          options: this.nonActiveServiceMembers
        })
      }
      return groups
    }
  },
  created() {
    this.selectedTags = this.value.map(id => this.staffMap[id])
    this.filteredTags = this.staffGroups
  },
  methods: {
    getFilteredTags(text) {
      const newData = []
      this.staffGroups.forEach(element => {
        const options = element.options.filter(
          item =>
            item.firstName.toLowerCase().indexOf(text.toLowerCase()) >= 0 ||
            item.lastName.toLowerCase().indexOf(text.toLowerCase()) >= 0
        )
        if (options.length) {
          newData.push({label: element.label, options})
        }
      })

      this.filteredTags = newData
    },
    updateValue() {
      this.$emit(
        'input',
        this.selectedTags.map(t => t._id)
      )
    }
  }
}
</script>
